import script from "./JoinUs.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinUs.vue?vue&type=script&setup=true&lang=js"

import "./JoinUs.vue?vue&type=style&index=0&id=1229c52a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1229c52a"]])

export default __exports__